import { render, staticRenderFns } from "./AgendaForm.vue?vue&type=template&id=bf8dbd7e&scoped=true"
import script from "./AgendaForm.vue?vue&type=script&lang=js"
export * from "./AgendaForm.vue?vue&type=script&lang=js"
import style0 from "./AgendaForm.vue?vue&type=style&index=0&id=bf8dbd7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8dbd7e",
  null
  
)

export default component.exports